import { Coffee, UtensilsCrossed, Flame, ShoppingCart, Sandwich, Pizza, Wine, Store } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";

const activities = [
  { icon: Coffee, title: "Bar & Caffetterie", desc: "Somministrazione di bevande, alcolici e alimenti al banco o al tavolo." },
  { icon: UtensilsCrossed, title: "Ristoranti & Trattorie", desc: "Preparazione e somministrazione di pasti e bevande." },
  { icon: Flame, title: "Tavole Calde & Fast Food", desc: "Somministrazione rapida di cibi e bevande al pubblico." },
  { icon: ShoppingCart, title: "Supermercati & Minimarket", desc: "Vendita di alimenti, bevande e prodotti confezionati o sfusi." },
  { icon: Sandwich, title: "Gastronomie & Rosticcerie", desc: "Preparazione, manipolazione e vendita di cibi pronti." },
  { icon: Pizza, title: "Pizzerie & Asporto", desc: "Somministrazione e vendita da asporto di alimenti e bevande." },
  { icon: Wine, title: "Pub & Wine Bar", desc: "Somministrazione di bevande alcoliche e somministrazione alimentare." },
  { icon: Store, title: "Vendita di Alimenti", desc: "Qualsiasi attività commerciale con vendita o manipolazione di cibo." },
];

export default function Destinatari() {
  return (
    <section id="destinatari" className="border-t border-line bg-white py-16 md:py-24" data-testid="destinatari-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeading
          eyebrow="A chi serve"
          title="Chi deve fare il corso SAB"
          sub="L'abilitazione è obbligatoria per titolari, soci e collaboratori di ogni attività in cui è prevista la somministrazione o la vendita di alimenti e bevande."
          testid="destinatari"
        />
        <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {activities.map((a, i) => (
            <Reveal key={a.title} delay={(i % 4) * 0.08}>
              <div
                className="group h-full border border-line bg-paper p-6 transition-all duration-300 hover:-translate-y-1 hover:border-navy hover:shadow-xl"
                data-testid={`destinatari-card-${i}`}
              >
                <div className="flex h-11 w-11 items-center justify-center bg-navy text-white transition-colors group-hover:bg-brand-amber">
                  <a.icon className="h-5 w-5" />
                </div>
                <h3 className="mt-5 font-heading text-lg font-bold tracking-tight text-navy">{a.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-600">{a.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
